import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import Template1 from './template1';
import Template2 from './template2';

import InputButton from '../../../../../../components/ZUILib/InputButton';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
import ModalPopover from './../../../../../../components/ZUILib/ModalPopover';
import SelectionTab from '../../../../../../components/ZUILib/SelectionTab';
import SelectOption from '../../../../../../components/ZUILib/SelectOption';
import Link from '../../../../../../components/ZUILib/Link';
import TextInput from '../../../../../../components/ZUILib/TextInput';
import Favourite from '../../../../../../components/ZUILib/Favourite';
import pdfUtil from '../../../../../../utils/PDFUtil';
import * as giftListActions from '../../actions';
import commonUtil from '../../../../../../utils/commonUtil';
import DownloadPDFWithoutPreview from '../../../../../../components/DownloadPDFWithoutPreview';
import * as defaultConst from '../../../../../../utils/clientConstant';
import serverClientUtil from '../../../../../../utils/serverClientUtil';
import EmptyGiftListIndicator from '../EmptyGiftListIndicator';
import GiftListCategories from '../../components/GiftListContent/GiftListCategories';
import Accordion from '../../components/Accordion';
import RadioButton from '../../../../../../components/ZUILib/RadioButton';
import ReactWebShare from '../../../../../../components/ReactWebShare';
import MobileTooltip from './MobileTooltip';
import { downLoadGiftListIcon } from '../../../../../createEvent/page/SelectMesaType/components/svgIcons';
import AddGiftsButton from '../../components/GiftListContent/AddGiftsButton';


const { updateGiftItemDetails,
  setFavouriteGift,
  removeItemsFromGiftlist,
  handleRemoveItemsFromGiftlist,
  changeDeliveryAddress,
  changeDeliveryMode,
  handleChangeDeliveryMode,
  handleChangeDeliveryAddress,
  getRegisteredGiftList,
  updateFavouriteToRegisteredGiftList } = giftListActions;
  const pageName = 'lista-de-regalos';

const applicationRoutes = commonUtil.getApplicationRoutes();
const predefinedStatus = [defaultConst.eventStatus.ADMINISTRATIVE_PROCESS, defaultConst.eventStatus.SUSPENDED, defaultConst.eventStatus.ACTIVE];
const eventTypes = [defaultConst.eventType.Bar_Mitzvah, defaultConst.eventType.Bat_Mitzvah, defaultConst.eventType.Baptism, defaultConst.eventType.First_Communion, defaultConst.eventType.Confirmacion, defaultConst.eventType.Other_Religious_Ceremonies, defaultConst.eventType.XV_Anos, defaultConst.eventType.Fiesta_Infantil];
const hideSelectionDropDownStatus = [defaultConst.eventStatus.VALIDITY_OFF_ACTIVE, defaultConst.eventStatus.CLOSED];
const brand = commonUtil.getBrand();
const colors = { LP: '#E10098', GAP: '#122344', PB: '#970400', PBK: '#74b0e2', WS: '#e81818', WLM: '#ed2724', TRU: '#007bff' };

class FilterTag extends Component {
  render() {
    const { label, onRemove } = this.props;

    return (
      <div className="filter-tag">
        <span>{label}</span>
        <span
        className="remove-tag"
          onClick={onRemove}
        >
          ×
        </span>
      </div>
    );
  }
}

class RegistradosContent extends Component {
  constructor(props) {
    super(props);
    this.giftItem = [];
    this.state = {
      modalId: '',
      sortingType: 'Ascending',
      searchKeyword: '',
      selecetdGiftItem: [],
      selectedGiftItem: {},
      count: 0,
      searchFlag: true,
      confirmationMessage: '',
      actionType: '',
      addressSelected: '',
      modeSelected: '',
      registeredGiftList: [],
      deliveryAddressInfo: [],
      originalRegisteredGiftList: _.isObject(props.originalRegisteredGiftList)
        ? props.originalRegisteredGiftList
        : { categoryItemsInfo: [], deliveryAddressInfo: [], itemsInfo: [], links: [], certificateItemsInfo: [] },
      isFavourite: false,
       seletedOption: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label'),
       activeCategory: '',
       categoryDepartmentId: [],
        tempCategoryName: '',
        totalItems:'',
        selectedFilters: [],
        activeFilters :[],
        updateHasChanges: false,
        originalGiftItem: {},
        showButton: false,
        isAddressChanged: false,
        isFilterApplied: false
    };
    this.checkMyCheckBox = false;
    this.isFavouriteSet = false;
    this.initialGiftListItems= props.initialGiftListItems || {}
  }
  isFav = '';
  registeredGiftList = []
  categoryInfo = []
  deliveryAddressInfo = []
  selectedGift = []
  searchedValue = '';

  handlePDFDownload = () => {
    if (this.state.categoryDepartmentId.length === 0) {
      this.setState({ shouldDownloadPdf: true }, () => {
        this.props.handleSortAndFilter(undefined, true);
      });
    } else {
      this.generateAndDownloadPdf();
    }
  };

  generateAndDownloadPdf = () => {
    const downloadableContent = (<DownloadPDFWithoutPreview pageName printingDate={this.props.printingDate} download>
      <Template2
        categoryInfo={this.state.categoryDepartmentId.length === 0 ? this.props.allRegisteredGifts.categoryItemsInfo : this.props.categoryInfo}
        lables={this.props.lables}
        registeredGiftList={this.state.registeredGiftList}
        deliveryAddressInfo={this.state.deliveryAddressInfo}
        eventDate={this.props.eventDate}
        eventId={this.props.eventId}
        eventType={this.props.eventType}
        giftCount={this.props.giftCount}
      /> </DownloadPDFWithoutPreview>);
    pdfUtil.attachToDom(downloadableContent, pageName);
  }

  giftSettingsSelect = () => {
    const one = document.querySelector('#selectAll');
    if (one.className === 'selectAll btn-group') {
      document.querySelector('#selectAll').classList.add('open');
    } else {
      one.classList.remove('open');
    }
  }
  showSharing = () => {
    this.props.shareModal.handleShow();
  }
  showHidden = (e) => {
    const { itemsInfo: registeredGifts = [], certificateItemsInfo: registeredGiftCertificates = [] } = this.state.originalRegisteredGiftList;
    const allRegisteredItems = [...registeredGifts, ...registeredGiftCertificates];
    const selecetdGiftItem = [];
    if (e.checked) {
      allRegisteredItems.forEach((itemInfo) => {
        selecetdGiftItem.push(itemInfo.giftItemId);
        this.giftItem.push(itemInfo);
      });
    }
    this.setState({ selecetdGiftItem });
    if (selecetdGiftItem.length) {
      document.querySelector('#footerBarOptionsRegisteredGifts').style.display = 'block';
    } else {
      document.querySelector('#footerBarOptionsRegisteredGifts').style.display = 'none';
    }
  };
  increment = () =>
    this.setState({ count: this.state.count < 999 ? this.state.count + 1 : this.state.count }, this.checkForChanges)

  decrement = () =>
    this.setState({ count: this.state.count >= 2 ? this.state.count - 1 : 1 }, this.checkForChanges);

  removeItemsFromGiftlist = () => {
    this.setState({ confirmationMessage: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.registrados.delete.product.confirmation.popup.message'), actionType: 'delete' }, this.checkForChanges);
    this.setModalId('deleteGiftModal');
    this.modalForUpdateConfirmation.handleShow();
  }

  dismissDelete = () => {
    this.modalForUpdateConfirmation.handleHide();
  };

  confirmAction = () => {
    if (this.state.actionType === 'delete') {
      this.confirmDelete();
    } else if (this.state.actionType === 'address') {
      this.confirmAddressChange(this.state.addressSelected);
    } else if (this.state.actionType === 'mode') {
      this.confirmModeChange(this.state.modeSelected);
    }
  }


  confirmDelete = () => {
    const removeGiftItems = [];
    for (let i = 0; i < this.state.selecetdGiftItem.length; i++) {
      removeGiftItems.push(this.state.selecetdGiftItem[i]);
    }

    handleRemoveItemsFromGiftlist(this.props.eventId, removeGiftItems).then((response) => {
      this.isChanged = false;
      if (response.body.status.status === 'success') {
        this.props.getRegisteredGiftList(this.props.eventId, this.state.sortingType, '', '', '', true, this.state.categoryDepartmentId);
        this.isChanged = false;
        document.querySelectorAll('input[name=checkboxGift]:checked').forEach((item) => { const ele = item; ele.checked = false; });
        this.showHidden(false);
      }
    }).catch((e) => { console.log(e); }); // console required
  };


  hideAndReset = () => {
    const hiddenField = document.querySelector('#footerBarOptionsRegisteredGifts').style.display;
    if (hiddenField === 'block') {
      document.querySelector('#footerBarOptionsRegisteredGifts').style.display = 'none';
    }
  }
  mergeCategoryResponses = (response1 = [], response2 = []) => {
    const map = new Map();

    const responses = [
      response1,
      response2,
    ];

    responses.forEach((list) => {
      if (!Array.isArray(list)) return;

      list.forEach((category) => {
        const key = `${category.categoryName}|${category.departmentId}`;

        if (!map.has(key)) {
          map.set(key, {
            ...category,
            itemInfo: [],
            _products: new Set(),
          });
        }

        const stored = map.get(key);

        (category.itemInfo || []).forEach((item) => {
          const productKey = item.skuId || item.productId;

          if (!stored._products.has(productKey)) {
            stored._products.add(productKey);
            stored.itemInfo.push(item);
          }
        });
      });
    });

    return {
      categoryItemsInfo: Array.from(map.values()).map(
        ({ _products, ...cat }) => cat,
      ),
    };
  };


  componentWillReceiveProps(nextProps) {
    const originalRegisteredGiftList = nextProps.originalRegisteredGiftList;
    const originalRegisteredGiftListChanged = originalRegisteredGiftList !== this.props.originalRegisteredGiftList;
    if (_.isObject(originalRegisteredGiftList) && originalRegisteredGiftListChanged) {
      if (Number(originalRegisteredGiftList.currentPage) === 1 || !_.isArray(originalRegisteredGiftList.itemsInfo)) {
        this.setState({ originalRegisteredGiftList });
      } else {
        originalRegisteredGiftList.itemsInfo = [...this.state.originalRegisteredGiftList.itemsInfo, ...originalRegisteredGiftList.itemsInfo];
        originalRegisteredGiftList.certificateItemsInfo = [...this.state.originalRegisteredGiftList.certificateItemsInfo, ...originalRegisteredGiftList.certificateItemsInfo];
        originalRegisteredGiftList.categoryItemsInfo = this.mergeCategoryResponses(this.state.originalRegisteredGiftList.categoryItemsInfo, originalRegisteredGiftList.categoryItemsInfo)?.categoryItemsInfo;
        this.setState({ originalRegisteredGiftList });
      }
    }

    this.registeredGiftList = nextProps.registeredGiftList && nextProps.registeredGiftList.categoryItemsInfo ? nextProps.registeredGiftList.categoryItemsInfo : [];
    this.deliveryAddressInfo = nextProps.registeredGiftList && nextProps.registeredGiftList.deliveryAddressInfo ? nextProps.registeredGiftList.deliveryAddressInfo : [];
    this.setState({
      registeredGiftList: this.registeredGiftList,
      deliveryAddressInfo: this.deliveryAddressInfo,
    });
    this.modalForUpdateConfirmation.handleHide();
  }
  searchArticle = () => {
    const searchTab = document.querySelector('#searchBox').style.display;
    if (searchTab === 'none') {
      document.querySelector('#searchBox').style.display = 'block';
    } else {
      document.querySelector('#searchBox').style.display = 'none';
    }
  }

  // this function callback by children to set state of the selecetd Value
  selectedItem = (giftItem, status) => {
    this.giftItem = this.giftItem.filter(item => item.giftItemId !== giftItem.giftItemId);
    let newSelectedGiftList = Object.assign([], this.state.selecetdGiftItem);
    if (!status) {
      newSelectedGiftList = newSelectedGiftList.filter(item => item !== giftItem.giftItemId);
    }
    if (status) {
      this.giftItem.push(giftItem);
      newSelectedGiftList.push(giftItem.giftItemId);
    }
    this.setState({
      selecetdGiftItem: newSelectedGiftList,
    });
    if (newSelectedGiftList.length) {
      document.querySelector('#footerBarOptionsRegisteredGifts').style.display = 'block';
    } else {
      document.querySelector('#footerBarOptionsRegisteredGifts').style.display = 'none';
    }
  }

  selectAllGifts = (e) => {
    const { itemsInfo: registeredGifts = [], certificateItemsInfo: registeredGiftCertificates = [] } = this.state.originalRegisteredGiftList;
    const allRegisteredItems = [...registeredGifts, ...registeredGiftCertificates];
    this.selectedGift = [];
    if (e.checked) {
      allRegisteredItems.forEach((registeredGift) => {
        this.selectedGift.push(registeredGift);
      });
    }

    this.checkMyCheckBox = e.checked;

    this.setState({
      ...this.state,
      seletedOption: e.checked ? commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label') : commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label'),
      isGiftSelected: this.selectedGift.length && true,
    });
    this.showHidden(this.selectedGift.length && true);
  }


  //sortType = 'Ascending';
  changeDeliveryModeOption = (selectedMode) => {
    this.setState({ confirmationMessage: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.registrados.change.delivery.mode.confirmation.popup.message'), actionType: 'mode', modeSelected: selectedMode }, this.checkForChanges);
    this.setModalId('changeGiftModal');
    setTimeout(() => { this.modalForUpdateConfirmation.handleShow(); }, 300);
  }

  confirmModeChange = (selectedMode) => {
    this.electronicItemsIds = [];
    if (this.registeredGiftList.length > 0) {
      let registedGifts = [];
      registedGifts = this.registeredGiftList.filter(gif => (gif.categoryName === 'Gift Certificate' || gif.categoryName === 'Certificado Electrónico'));
      if (registedGifts && registedGifts.length > 0) {
        this.electronicItemsIds = registedGifts[0].itemInfo.map(element => (element.giftItemId));
      }
    }
    let skus = _.pullAll(this.state.selecetdGiftItem, this.electronicItemsIds);
        skus = skus.length > 0 ? skus : this.electronicItemsIds;
    handleChangeDeliveryMode(this.props.eventId, skus, this.state.sortingType, [], selectedMode.id).then((response) => {
      if (response.body.status?.status === 'success') {
        JSON.parse(JSON.stringify(this.props.handleBulkAction(response.body.categoryItemsInfo, 'modeChange')));
        this.isChanged = false;
        this.selectedGift.forEach((item) => {
          const _item = item;
          // _item.checked = false;
          // document.querySelector('#check_' + item.skuId).checked = false;
        },
        );
        this.giftItem = [];
        document.querySelectorAll('input[name=check]:checked').forEach((item) => { const ele = item; ele.checked = false; });
        const itemsInfo = response.body.categoryItemsInfo
          .map(cif => cif.itemInfo)
          .reduce((acc, curr) => [...acc, ...curr], []);
        itemsInfo.forEach(itemInfo => this.updateGiftItemInfo(itemInfo));
      }
    }).catch((e) => { console.log(e); }); // console required
    // document.querySelector('#deliveryMode').selectedIndex = 0;
    this.showHidden(false);
  }

  changeDeliveryAddressOption = (selectedAddress) => {
    this.setState({ confirmationMessage: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.registrados.change.delivery.address.confirmation.popup.message'), actionType: 'address', addressSelected: selectedAddress });
    this.setModalId('changeAddressModal');
    setTimeout(() => { this.modalForUpdateConfirmation.handleShow(); }, 300);
  }
  confirmAddressChange = (selectedAddress) => {
    this.physicalItemIds = [];
    for (let i = 0; i < this.state.selecetdGiftItem.length; i++) {
      if (this.giftItem[i].deliveryMode !== 'electronic') {
        this.physicalItemIds.push(this.giftItem[i].giftItemId);
      }
    }
    handleChangeDeliveryAddress(this.props.eventId, this.physicalItemIds, selectedAddress.id).then((response) => {
      if (response.body.status?.status === 'success') {
        JSON.parse(JSON.stringify(this.props.handleBulkAction(response.body.categoryItemsInfo, 'addressChange')));
        this.isChanged = false;
        document.querySelectorAll('input[name=check]:checked').forEach((item) => { const ele = item; ele.checked = false; });
        const itemsInfo = response.body.categoryItemsInfo
          .map(cif => cif.itemInfo)
          .reduce((acc, curr) => [...acc, ...curr], []);
        itemsInfo.forEach(itemInfo => this.updateGiftItemInfo(itemInfo));
      }
    }).catch((e) => { console.log(e); }); // console required
    // document.querySelector('#deliveryAddress').selectedIndex = 0;
    this.showHidden(false);
  }
  showUpdateGiftDetailsModalWithProductData = (giftItem) => {
    this.updateGiftDetails.handleShow();
    this.favourite.clearState();
    this.isFavouriteSet = giftItem.isFavourite;
    this.setState({
      selectedGiftItem: giftItem,
      count: parseInt(giftItem.quantity, 10),
      isFavourite: giftItem.isFavourite,
      originalGiftItem: { ...giftItem },
      updateHasChanges: false,
    });
  }
  showCertificateDetailsModalWithProductData = (giftItem) => {
    this.modalForSetFavourite.handleShow();
    this.favouriteGC.clearState();
    this.isFavouriteSet = giftItem.isFavourite;
    this.setState({
      selectedGiftItem: giftItem,
      count: 1,
      isFavourite: giftItem.isFavourite,
      originalGiftItem : {...giftItem}
    });
  }
  setFavouriteGiftValue = (e, item) => {
    this.isFav = (!item.isFavourite).toString();
    this.isFavouriteSet = this.favourite.checked;

    const isGiftCertificate = ['Gift Certificate', 'Certificado Electrónico'].includes(item.categoryName);
    if (isGiftCertificate) {
      this.setState({ isFavourite: this.favouriteGC.checked }, this.checkForChanges);
    } else {
      this.setState({ isFavourite: this.favourite.checked }, this.checkForChanges);
    }
  }
  updategiftItemDetail = () => {
    const quantity = this.state.count.toString();
    const isFavourite = this.state.isFavourite.toString();
    const addressId = this.state.selectedGiftItem.addressId || (this.deliveryAddressDetails.length > 0 ? this.deliveryAddressDetails[0].id : '');
    const modeId = this.state.selectedGiftItem.deliveryMode;
  
    // updateGiftItemDetails(this.props.eventId, this.state.selectedGiftItem.giftItemId, quantity, addressId || 'noCelebratedOwner', modeId, isFavourite).then(
    updateGiftItemDetails(this.props.eventId, this.state.selectedGiftItem.giftItemId, quantity, addressId, modeId, isFavourite).then(
      (response) => {
        if (response.body.status?.status === 'success') {
          this.props.handleBulkAction(response.body, 'update', modeId);
          this.setState({ ...this.state });
          this.updateGiftDetails.handleHide();
          this.modalForSetFavourite.handleHide();
          this.props.updateFavouriteToRegisteredGiftList(this.state.selectedGiftItem.giftItemId, isFavourite === 'true');
          this.updateGiftItemInfo({
            ...response.body.itemInfo,
            addressId: response.body.itemInfo.deliveryAddress,
            deliveryMode:  response.body?.itemInfo?.modeOfDelivery || response.body.itemInfo.deliveryType,
          });

          this.props.handleSortAndFilter({ priceOrder: 'Ascending' })
        }
      }).catch((err) => { console.log(err); }); // console required
  }


  setFavouriteGiftForCertificate = () => {
    setFavouriteGift(this.props.eventId, this.state.selectedGiftItem.giftItemId, this.state.selectedGiftItem.skuId, this.state.isFavourite.toString()).then((response) => {
      if (response.body.status.success === 'success') {
        this.props.handleBulkAction(response, 'favourite', this.isFav === 'true', this.state.selectedGiftItem.giftItemId);
        this.setState({ ...this.state });
        this.modalForSetFavourite.handleHide();
        this.props.updateFavouriteToRegisteredGiftList(this.state.selectedGiftItem.giftItemId, this.isFav === 'true');
        const certificateItemsInfo = _.get(this.state, 'originalRegisteredGiftList.certificateItemsInfo', []).map(
          (registeredGiftCertificate) => {
            if (registeredGiftCertificate.giftItemId === this.state.selectedGiftItem.giftItemId) {
              return { ...registeredGiftCertificate, isFavourite: this.state.isFavourite };
            }
            return registeredGiftCertificate;
          },
        );
        const originalRegisteredGiftList = {
          ...this.state.originalRegisteredGiftList,
          certificateItemsInfo,
        };

       //this.props.handleSortAndFilter({ priceOrder: 'Ascending' })

        this.setState({ originalRegisteredGiftList });
      }
    }).catch((err) => { console.log(err); }); // console required
  }

  onSearchAreaKeyUp = (e) => {
    if (e.keyCode === 13) {
      this.showHidden(false);
      document.querySelectorAll('input[name=check]:checked').forEach((item) => { const ele = item; ele.checked = false; });
   // Service Call
      this.setState({ searchKeyword: this.searchGift.getValue(), searchFlag: false });
      this.props.handleSortAndFilter({ searchKeyword: this.searchGift.getValue(), currentPage: 1 });
      this.searchedValue = this.searchGift.getValue();
    }
    if (!e.target.value.length) {
      this.showHidden(false);
      document.querySelectorAll('input[name=check]:checked').forEach((item) => { const ele = item; ele.checked = false; });
      this.setState({ searchFlag: true });
      this.props.handleSortAndFilter({ currentPage: 1 });
    }
  }
  clearSearch = () => {
    const searchTab = document.querySelector('#searchBox').style.display;
    if (searchTab === 'block') {
      document.querySelector('#searchBox').style.display = 'none';
    }
    this.showHidden(false);
    document.querySelectorAll('input[name=check]:checked').forEach((item) => { const ele = item; ele.checked = false; });
    this.setState({ searchKeyword: '', searchFlag: true });
    this.props.handleSortAndFilter({ currentPage: 1 });
    this.searchGift = '';
    document.getElementById('searchArea').value = '';
  }
  onClickSearchResult=() => {
    this.showHidden(false);
    document.querySelectorAll('input[name=check]:checked').forEach((item) => { const ele = item; ele.checked = false; });
    this.setState({ searchKeyword: this.searchGift.getValue(), searchFlag: false });
    this.props.handleSortAndFilter({ searchKeyword: this.searchGift.getValue(), currentPage: 1 });
    this.searchedValue = this.searchGift.getValue();
  }
  quantityUpdate = (e) => {
    const value = e.target.value;

    if (value === "") {
      this.setState({ count: 1 }, this.checkForChanges);
      return;
    }

    if (value === "0") {
      this.setState({ count: 1 }, this.checkForChanges);
      return;
    }

    if (value.length <= 3) {
      const parsed = parseInt(value, 10);

      if (!isNaN(parsed)) {
        this.setState({ count: parsed }, this.checkForChanges);
      }
    }
  }

  closeModal = () => {
    this.modalForSetFavourite.handleHide();
    this.updateGiftDetails.handleHide();
    this.setState({ updateHasChanges: false})
  }
  closeSharingModal=() => {
    this.props.shareModal.handleHide();
  }
  setModalId = (id) => {
    this.setState({ modalId: id });
  }
  deliveryModeIndividualGiftUpdate = (e) => {
    const updateSelectedItem = JSON.parse(JSON.stringify(this.state.selectedGiftItem));
    updateSelectedItem.deliveryMode = e.id;
    this.setState({
      ...this.state,
      selectedGiftItem: updateSelectedItem,
    }, this.checkForChanges);
  }

  handleAddressChange = (addressId, initialAddress= false) => {
    const updateSelectedItem = JSON.parse(JSON.stringify(this.state.selectedGiftItem));
    updateSelectedItem.addressId = addressId;
    const selectedAddress = this.deliveryAddressInfo.find(addr => addr.deliveryAddressId === addressId);
    const addressChanges = initialAddress ? true : false;
    updateSelectedItem.deliveryAddressName = selectedAddress ? selectedAddress.deliveryAddressName : '';
    this.setState({
      ...this.state,
      selectedGiftItem: updateSelectedItem,
      isAddressChanged: addressChanges
    }, () => this.checkForChanges());
  }

  checkForChanges = () => {
    const { selectedGiftItem, originalGiftItem, count, isFavourite } = this.state;

    const quantityChanged = count !== parseInt(originalGiftItem.quantity, 10);
    const favouriteChanged = isFavourite !== originalGiftItem.isFavourite;
    const deliveryModeChanged = selectedGiftItem.deliveryMode !== originalGiftItem.deliveryMode;
    let addressChanged = false
    if (!this.state.isAddressChanged) {
      addressChanged = selectedGiftItem.addressId !== originalGiftItem.addressId;
    }

    this.setState({ 
      updateHasChanges: quantityChanged || favouriteChanged || deliveryModeChanged || addressChanged 
    });
  }

  handleAllowOnlyDigit = (e) => {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
    ];

    if (allowedKeys.includes(e.key)) {
      return;
    }

    if (!/^[0-9]$/.test(e.key)) {
      const keyCode = String.fromCharCode(e.which || e.keyCode);
      if (!/^[0-9]$/.test(keyCode)) {
        e.preventDefault();
      }
    }
  };

  onPasteFunc = (e) => {
    const text = e.clipboardData.getData('Text');
    const numericValue = text ? text.replace(/\D/g, '') : '';
    if (text !== numericValue) {
      e.preventDefault();
    }
  };

  updateGiftItemInfo = (giftDetails) => {
    const allowedGiftDetails = _.pick(giftDetails, [
      'addressId',
      'availability',
      'catalogRedirectionURL',
      'categoryName',
      'deliveryMode',
      'departmentId',
      'desc',
      'giftItemId',
      'imageURL',
      'isFavourite',
      'listPrice',
      'name',
      'productId',
      'productType',
      'quantity',
      'salePrice',
      'skuId',
      'sortPrice',
    ]);
    const definedGiftDetails = _.pickBy(allowedGiftDetails, giftDetail => !_.isNil(giftDetail));
    if (_.isNil(definedGiftDetails.giftItemId)) throw new Error('giftItemId has to be defined');
    const itemsInfo = this.state.originalRegisteredGiftList.itemsInfo.map((itemInfo) => {
      if (itemInfo.giftItemId === definedGiftDetails.giftItemId) return { ...itemInfo, ...definedGiftDetails };
      return { ...itemInfo };
    });
    const originalRegisteredGiftList = { ...this.state.originalRegisteredGiftList, itemsInfo };
    this.setState({ originalRegisteredGiftList });
  }

 handleCategoryChange = (selectedData) => {
  const categoryName = selectedData.value;
  const filteredCategory = this.props.registeredGifts.categoryList.find(
    category => category.categoryName === categoryName
  );

  const departmentId = filteredCategory && filteredCategory.departmentId && [String(filteredCategory.departmentId)] || []

  this.setState({
    tempCategoryName: categoryName,
    totalItems: filteredCategory ? filteredCategory.totalItems : 0,
    selectedFilters: [categoryName],
    activeFilters: selectedData.checked ? [{ type: 'category', value: categoryName }]  : [],
    categoryDepartmentId: departmentId,
  });
};

  removeFilter = (filter) => {
  this.setState(prevState => ({
    isFilterApplied:false,
    selectedFilters: prevState.selectedFilters.filter(item => item !== filter),
    tempCategoryName: prevState.tempCategoryName === filter ? '' : prevState.tempCategoryName
  }), () => {
    if (this.state.selectedFilters.length === 0) {
      this.setState({
        tempCategoryName: '',
        activeCategory: '',
        categoryDepartmentId: [],
        totalItems: '',
        activeFilters: []
      });

      this.props.getRegisteredGiftList(this.props.eventId, this.state.sortingType, '', '', '', true, []);
      document.querySelectorAll('input[name="categoryFilterRegistrados"]').forEach(radio => {
        radio.checked = false;
      });
    }
  });
};

  handleSaveFilters = () => {
  this.setState({ 
    activeCategory: this.state.tempCategoryName,
    isFilterApplied: true
  }, () => {
    this.filterModal.handleHide();
      this.props.getRegisteredGiftList(this.props.eventId, this.state.sortingType, '', '', '', true, this.state.categoryDepartmentId);
  });
};

  handleCloseFilterModal = () => {
    const isFiltered = this.state.isFilterApplied;
    if (!isFiltered) {
      this.setState({
        selectedFilters: [],
        tempCategoryName: '',
        activeCategory: '',
        categoryDepartmentId: [],
        totalItems: '',
        activeFilters: []
      }, () => {
        document.querySelectorAll('input[name="categoryFilterRegistrados"]').forEach(radio => {
          radio.checked = false;
        });
      });
    }
    this.filterModal.handleHide();
  }

handleClearFilters = () => {
  this.setState({ 
    selectedFilters: [],
    tempCategoryName: '',
    activeCategory: '',
    categoryDepartmentId: [],
    totalItems: '',
    activeFilters: [],
    isFilterApplied: false
  }, () => {
    this.filterModal.handleHide();
    this.props.getRegisteredGiftList(this.props.eventId, this.state.sortingType, '', '', '', true, []);
    document.querySelectorAll('input[name="categoryFilterRegistrados"]').forEach(radio => {
      radio.checked = false;
    });
  });
};
  handlePopUpCoOwner = (id, backdropId) => {
    const data = document.querySelector('#' + id);
    const backdrop = document.querySelector('#' + backdropId);
    if (data && backdrop) {
      data.style.display = (data.style.display === 'block') ? 'none' : 'block';
      backdrop.style.display = (backdrop.style.display === 'block') ? 'none' : 'block';
    }
}

  handleSortWap = () => {
    const sortingType = this.state.sortingType === 'Ascending' ? 'Descending' : 'Ascending'
    this.props.handleSortAndFilter({ priceOrder: sortingType })
    this.setState({ sortingType: sortingType });
  };

  handleScroll = () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    this.setState({
      showButton: scrollPercent > 25
    });
  }

  componentDidUpdate(prevProps) {
    if (this.deliveryAddressInfo.length > 0 && !this.state.selectedGiftItem.addressId) {
      const firstAddress = this.deliveryAddressInfo[0];
      this.handleAddressChange(firstAddress.deliveryAddressId, true);
      this.setState({isAddressChanged: true});
    }

    const finishedLoading =
      prevProps.loadingAllRegisteredGifts &&
      !this.props.loadingAllRegisteredGifts;
  
    if (this.state.shouldDownloadPdf && finishedLoading) {
      this.setState({ shouldDownloadPdf: false }, () => {
        this.generateAndDownloadPdf();
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  closeDeleteModal = () => {
    this.modalForDelete.handleHide();
  }

  deleteGiftItemDetail = () => {
    this.confirmDeleteGiftFromList();
    this.modalForDelete.handleHide();
  }

  showModalForDeleteModal = (giftItem) => {
    this.modalForDelete.handleShow();
    this.updateGiftDetails.handleHide();
  }

  showModalForDeleteModalFromGiftCertificate   = (giftItem) => {
    this.modalForDelete.handleShow();
    this.modalForSetFavourite.handleHide();
  }
  

  

  confirmDeleteGiftFromList = () => {
    const removeGiftItems = [];
    removeGiftItems.push(this.state.selectedGiftItem.giftItemId);

    handleRemoveItemsFromGiftlist(this.props.eventId, removeGiftItems).then((response) => {
      this.isChanged = false;
      if (response.body.status.status === 'success') {
        this.props.getRegisteredGiftList(this.props.eventId, this.state.sortingType, '', '', '', true, this.state.categoryDepartmentId);
        this.isChanged = false;
        document.querySelectorAll('input[name=checkboxGift]:checked').forEach((item) => { const ele = item; ele.checked = false; });
        this.showHidden(false);
        this.props.deletePopup.setMessage(commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.delete.article.element.gift.list'));
      }
    }).catch((e) => { console.log(e); });
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("touchstart", this.handleClickOutside);
    window.addEventListener("scroll", this.handleScroll);
    this.props.onRegistradosWapRef?.(this);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener("touchstart", this.handleClickOutside);
    this.props.onRegistradosWapRef?.(null);
  }


  render() {
    const { registeredGiftList, categoryInfo } = this.props;
    const { activeCategory } = this.state;

    const { itemsInfo: registeredGifts = [], itemsCount: totalRegisteredGifts, certificateItemsInfo: registeredGiftCertificates = [], recordsPerPage } =
      this.state.originalRegisteredGiftList;

    let filteredGifts = registeredGifts;
    if (this.state.activeCategory) {
      const activeCategories = this.state.activeCategory.split(',');
      filteredGifts = this.props?.registeredGifts?.categoryItemsInfo
        ?.filter(category => activeCategories.includes(category.categoryName))
        ?.flatMap(category => category.itemInfo || []);
    }

    const allRegisteredItems = [...registeredGifts, ...registeredGiftCertificates];
    const registeredItemsFound = allRegisteredItems.length > 0;
    const onlyGiftCertificates = allRegisteredItems.every(registeredItem =>
      ['Gift Certificate', 'Certificado Electrónico'].includes(registeredItem.categoryName),
    );
    const currentBrandColors = commonUtil.getCurrentBrandColors();
    const resultsPerPage = _.isFinite(Number(recordsPerPage)) ? Number(recordsPerPage) : 0;
    const showBackToTopButton = allRegisteredItems.length >= 7;
    // const socialSharePath = `http://grdev.liverpool.com.mx:3000${this.props.location}`;
    const loadMoreButton = {
      id: 'nextButton',
      type: 'button',
      value: 'Cargar más productos',
      autoFocus: false,
      style: 'btnSecondarySpecial size-Full',
      iconClass: '',
      onClickHandler: () => this.props.handleSortAndFilter({
        searchKeyword: this.searchGift.getValue(),
        currentPage: Number(this.state.originalRegisteredGiftList.currentPage) + 1,
        categoryDepartmentId: this.state.categoryDepartmentId,
      }),
      cssStyle: {
        fontFamily: 'robotoRegular',
      },
    };

    const goToTopButton = {
      id: 'goToTopOfList',
        type: 'button',
        value: <img src={commonUtil.getAssetURL() + "/images/arrow_upward.svg"} style={{height: '32px'}} />,
        autoFocus: false,
        style: 'size-Full goToTopOfList',
        iconClass: '',
        onClickHandler: commonUtil.goToTop,
        cssStyle:{
          backgroundColor: `var(--500, ${this.props.activeThemeColor || '#333'})`
        }
    }

    let values = '';
    if (document.querySelector('#mount-point')) {
      values = document.querySelector('#mount-point').value;
    }
    if (this.registeredGiftList.length === 0 || values === '') {
      this.registeredGiftList = this.props.registeredGiftList ? this.props.registeredGiftList : [];
    }
    if (this.deliveryAddressInfo.length === 0 || values === '') {
      this.deliveryAddressInfo = !commonUtil.isObjectEmpty(this.props.registeredGifts) && this.props.registeredGifts.deliveryAddressInfo ? this.props.registeredGifts.deliveryAddressInfo : [];
    }
    if (this.registeredGiftList.length && this.deliveryAddressInfo.length && this.state.registeredGiftList.length === 0 && this.state.deliveryAddressInfo.length === 0) {
      this.setState({
        registeredGiftList: this.registeredGiftList,
        deliveryAddressInfo: this.deliveryAddressInfo,
      });
    }
    this.deliveryAddressDetails = this.deliveryAddressInfo ? this.deliveryAddressInfo.map(addressSelection => ({ id: addressSelection.deliveryAddressId, value: addressSelection.deliveryAddressName })) : [];

    let selectedDeliveryMode = commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label');
    if (this.state.selectedGiftItem.deliveryMode === defaultConst.constGiftDeliveryMode.Físicos) {
      selectedDeliveryMode = commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label');
    } else selectedDeliveryMode = commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label');

    const CambiarModoDeRegalos =
      {
        htlmId: 'chooseParent',
        disable: false,
        defaultValue: selectedDeliveryMode,
        options: [{
          id: defaultConst.constGiftDeliveryMode.Físicos, // fisico
          value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label'),
          labelResourceId: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label'),
        }, {
          id: defaultConst.constGiftDeliveryMode.Electrónicos, // Electrónico
          value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label'),
          labelResourceId: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label'),
        }],
      };


    const CambiarModoDeRegalosOptionsForBulkAction = {
      id: 'chooseParent1',
      disable: false,
      defaultValue: '',
      selectCaption: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.gift.mode'),
      options: [{
        id: defaultConst.constGiftDeliveryMode.Físicos,
        value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label'),
        text: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label'),
        isEnabled: true,
      }, {
        id: defaultConst.constGiftDeliveryMode.Electrónicos,
        value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label'),
        text: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label'),
        isEnabled: true,
      }],
    };

    const DireccionOptionsForBulkAction = {
      id: 'chooseParent2',
      disable: false,
      defaultValue: '',
      selectCaption: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.item.address.label'),
      options: [
        // {
        //   id: 'noCelebratedOwner',
        //   value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.category.dropdown.label1'),
        //   text: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.category.dropdown.label1'),
        //   isEnabled: true,

        // },
      ],
    };

    if (this.deliveryAddressInfo) {
      this.deliveryAddressInfo.forEach((address) => {
        DireccionOptionsForBulkAction.options.push({
          id: address.deliveryAddressId,
          value: address.deliveryAddressName,
          text: address.deliveryAddressName,
          isEnabled: true,
        });
      });
    }

    const sharelinksData ={
      text: "",
      url: document.URL,
      title: "",
    }

    const SearchArticleButton = {
      type: 'button',
      id: 'searchArticle',
      style: 'mobileWhiteButton buscar-wap-button',
      value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.button.search.article'),
      onClickHandler: this.searchArticle,
      disabled: !registeredItemsFound,
      cssStyle: { opacity: registeredItemsFound ? '100%' : '33%' }
    };
    const FilterArticleButton = {
      type: 'button',
      id: 'filterArticle',
      style: 'mobileWhiteButton filter-wap-button wapFilterCount',
      value: 'Filtrar',
      filteredProducts : this.state.activeFilters ? this.state.activeFilters.length : 0,
      activeCategory: !_.isEmpty(activeCategory),
      disabled: !registeredItemsFound,
      cssStyle: { opacity: registeredItemsFound ? '100%' : '33%' },
      beforeIconClass: 'icon-tune',
      onClickHandler: () => this.filterModal.handleShow(),
    };
    const SortArticleButton = {
      type: 'button',
      id: 'sortArticle',
      style: 'mobileWhiteButton sort-wap-button',
      value: this.state.sortingType === 'Ascending' ? commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.lowest.wap.label') : commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.wap.label'),
      onClickHandler: () => this.handleSortWap(),
      disabled: !registeredItemsFound,
      cssStyle: { opacity: registeredItemsFound ? '100%' : '33%' },
      beforeIconClass: 'icon-swap',
      iconClass: 'glyphicon glyphicon-chevron-down sortIcon',
    };
    const SaveButton = {
      type: 'button',
      value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.button.save'),
      autoFocus: false,
      style: 'btn customBtnModalEnviar',
      onClickHandler: this.updategiftItemDetail,
      disabled: this.state.updateHasChanges ? false : true
    };
    const SaveButtonforGiftCertificate = {
      type: 'button',
      value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.button.save'),
      autoFocus: false,
      style: 'btn customBtnModalEnviar',
      onClickHandler: this.updategiftItemDetail,
      disabled: this.state.updateHasChanges ? false : true
    };

    const SaveButtonforFilter = {
      id:"Registradossavebtn",
      type: 'button',
      value: `Ver ${this.state.totalItems} artículos`,
      autoFocus: false,
      style: `btn customButtonGuardar ${!this.state.activeCategory ? 'widthFull' : ''}`,
      // cssStyle: { backgroundColor: this.props.activeThemeColor },
      onClickHandler: this.handleSaveFilters,
      disabled: this.state.selectedFilters.length === 0,
      themeColor: this.props.activeThemeColor || '#333',
    };

    const ClearButtonforFilter = {
      type: 'button',
      value: "Limpiar filtros",
      autoFocus: false,
      style: 'btn customButtonLimpiar',
      cssStyle: { border: `1px solid ${this.props.activeThemeColor || '#333'}`, color: this.props.activeThemeColor || '#333' },
      onClickHandler: this.handleClearFilters,
    };
    const headerData = (<div className="col-xs-4 text-right closeOptionModal pr-0" onClick={this.closeModal}><img
                src={commonUtil.getAssetURL() + "/images/close.svg"}
                alt=""
                className="icon_vozcliente"
              /></div>);
    const linkJSON1 = {
      route: '',
    };
    const modalLink = (<div className="basicLinks" onClick={registeredItemsFound ? this.showSharing : undefined}><a><i className="iClass icon-compartir" aria-hidden="true" />
    </a></div>);
    const isDisabled = this.props.compareEventStatus(this.props.eventStatus, defaultConst.RESTRICTED_EVENT_STATUSES);

    const totalRecords = registeredGiftList.totalRecords;
    let loadedRecordCount = 0;
    if (categoryInfo) {
      categoryInfo.forEach((item) => {
        const itemCount = item.itemInfo ? item.itemInfo.length : 0;
        loadedRecordCount += itemCount;
      });
    }
    const currentPage = this.props.registeredGiftList ? this.props.registeredGiftList.currentPage : 0;
    const sortType = this.state.sortingType;
    this.props.setTotalRecordsForType('tabregistered', totalRecords, loadedRecordCount, sortType, currentPage);
    const categoryInfoToRender = categoryInfo;


    const accordionData = [
      {
        title: <span><strong>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliverymode.label')}:&nbsp;</strong><span className='fontWeightNormal'>{(this.state.selectedGiftItem.deliveryMode === defaultConst.constGiftDeliveryMode.Electrónicos) ? commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label') : commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label') }</span></span>,
        content: (
          <div className="deliverModeSelect">
            {CambiarModoDeRegalosOptionsForBulkAction?.options.map((ele, idx) => (
              <button id={ele.id} key={idx} 
                className={this.state.selectedGiftItem.deliveryMode === ele.id ? 'selected' : ''}
                onClick={() => this.deliveryModeIndividualGiftUpdate(ele)}
              >{ele.text}</button>
            ))}
          </div>
        ),
        showOnLoad: true,
      }
    ];

    const accordianFilterData = [
      {
     title: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.category.filter.title.label'), 
     content: (
          <div className="category-radio-group">
            {this.props.registeredGifts?.categoryList?.map((ele, idx) => (
              <div key={idx} className="radio-label-wrapper">
                <span>{ele.categoryName}</span>
                <RadioButton
                  id={`category-${idx}`}
                  name="categoryFilterRegistrados"
                  value={ele.categoryName}
                  displayName=""
                  radioCssClass="radio op-0"
                  checked={this.state.tempCategoryName === ele.categoryName}
                  onChangeFunction={this.handleCategoryChange}
                />
              </div>
            ))}
          </div>

        ),
    showOnLoad: true,
    }
    ]

    if (this.state.selectedGiftItem.deliveryMode === defaultConst.constGiftDeliveryMode.Físicos && this.deliveryAddressDetails.length > 0) {
          accordionData.push({
            title: <><strong>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.item.address.label')}: </strong><span className='fontWeightNormal'>{
            this.state.selectedGiftItem.addressId 
              ? this.deliveryAddressInfo.find(addr => addr.deliveryAddressId === this.state.selectedGiftItem.addressId)?.deliveryAddressName 
              : (this.deliveryAddressInfo[0]?.deliveryAddressName || '')
          }</span>
          </>,
            content: (
              <div className="radio-btn radio-del-address-container">
                {this.deliveryAddressInfo.map((ele, idx) => (
                  <div className='radios-delivery-address' key={idx}>
                    <input
                      // displayName={ele.deliveryAddressName}
                      name="deliveryAddress"
                      value={ele.deliveryAddressId}
                      type="radio"
                      id={ele.deliveryAddressId}
                      checked={this.state.selectedGiftItem.addressId === ele.deliveryAddressId}
                      style={{
                        accentColor: `${colors[brand]}`,
                        marginRight: '10px',
                      }}
                      onChange={() => this.handleAddressChange(ele.deliveryAddressId)}
                      ref={ref => this.deliveryAddressID = ref}
                    />
                    <label className='radio-del-label' htmlFor={ele.deliveryAddressId}>
                      {ele.deliveryAddressName}
                    </label>
                  </div>
                // <RadioButton 
                //   key={idx} 
                //   displayName={ele.deliveryAddressName} 
                //   value={ele.deliveryAddressId} 
                //   id={ele.deliveryAddressId} 
                //   radioCssClass={'radio'} 
                //   name="deliveryAddress"
                //   checked={this.state.selectedGiftItem.addressId === ele.deliveryAddressId ? true : ele.deliveryAddressId === this.deliveryAddressInfo[0]?.deliveryAddressId}
                //   ref={ref => this.deliveryAddressID = ref}
                //   onChangeFunction={() => this.handleAddressChange(ele.deliveryAddressId)}
                // />
                ))} 
              </div>
            ),
            showOnLoad: true,
          });
        }

    const DeleteButtonforGift = {
      type: 'button',
      value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.elimination.buttton.label'),
      autoFocus: false,
      style: 'btn customBtnModalEnviar btnCancelarGift delButtonsHeight',
      onClickHandler: this.deleteGiftItemDetail,
    };
    const CancelDeleteButtonforGift = {
      type: 'button',
      value: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosrecibidos.delete.status.for.cancel'),
      autoFocus: false,
      style: 'btn customBtnModalEnviar delButtonsHeight',
      onClickHandler: this.closeDeleteModal,
    };

    return (
      <React.Fragment>
        <ModalPopover
          modalId={this.state.modalId}isModal="true" modalClass="modal fade in"
          ref={modalForUpdateConfirmation => this.modalForUpdateConfirmation = modalForUpdateConfirmation} handleOutsideClick
        >
          <p>{this.state.confirmationMessage}</p>
          <div className="row">
            <div className="col-xs-6">
              <button className="btnSecondary size-Full" onClick={this.dismissDelete}>Cancelar</button>
            </div>
            <div className="col-xs-6">
              <button className="btnPrimaryAction size-Full" onClick={this.confirmAction}>Aceptar</button>
            </div>
          </div>
        </ModalPopover >
        <div className="container-fluid">
          <div className="row">
            {this.initialGiftListItems.totalRecords >0 &&
            <div className="col-xs-12 giftList-filters giftlist-wap-filters">
              <div className="row buscar-icons-wap-list">
                {registeredItemsFound && (<div className="col-xs-6 giftlist-wap-container-section">
                  <InputButton buttonAttr={SearchArticleButton} />
                </div>)}
                {registeredItemsFound &&
                <div className="col-xs-6">
                 <span className='pull-right giftlist-wap-share-download-container'>
                   <Link rrLink={linkJSON1} >
                     <span dangerouslySetInnerHTML={{__html: downLoadGiftListIcon}} className='download-gift-list-icon-wap'
                         onClick={registeredItemsFound ? () => this.handlePDFDownload() : undefined}
                     />
                      {/* <i className="iClass icon-descarga" onClick={registeredItemsFound ? () => this.handlePDFDownload() : undefined} aria-hidden="true" /> */}
                    </Link>
                    <ReactWebShare data={sharelinksData}/>
                 </span>
                     {/* {this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.ACTIVE) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS) ? modalLink : <a> <i className="iClass icon-compartir" aria-hidden="true" /></a>} */}
                </div>
                }
              </div>
            </div>
            }
            <div className="searchProductBlockRegistered" id="searchBox" style={{ display: 'none' }}>
            <div className="col-xs-12">

              <div className="input-group">
                <TextInput
                  className="form-control"
                  htmlId="searchArea"
                  placeholder={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.search.message')}
                  required="true"
                  star=""
                  ref={txt => this.searchGift = txt}
                  onKeyUp={this.onSearchAreaKeyUp}
                />
                <span className="input-group-btn">
                  {this.state.searchFlag
                    ?
                      <button className="btn btn-default" type="button" onClick={this.onClickSearchResult}><i className="icon-zoom" />
                      </button> :
                      <button className="btn btn-default" type="button" onClick={this.clearSearch}><i className="icon-tache2" /></button>
                  }
                </span>
              </div>

            </div>
          </div>
            {this.initialGiftListItems.totalRecords > 0 &&
              <>
             {registeredItemsFound && (<div className="col-xs-12  giftListFiltersSection giftslist-wap-double-button-container">
              <div className="row">
                <div className={`col-xs-3 pr-0 ${activeCategory ? 'activeFilterCategory' : ''}`}>
                  <InputButton buttonAttr={FilterArticleButton} activeThemeColor={this.props.activeThemeColor} />
                </div>
                {registeredItemsFound  &&
                <div className="col-xs-8 pr-0 pl-0">
                  <InputButton buttonAttr={SortArticleButton} />
                </div>
                }
              </div>
            </div>)}
            {registeredItemsFound &&
            <div className="col-xs-12 selectAllRGContainer">
              <div className="selectAllRG">
                    <CheckBox
                      displayName={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label')}
                      id="selectRegisteredGiftAll"
                      name="check"
                      checkStatus="false"
                      getSelectedValue={this.showHidden}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
            }
              </>
            }            
          </div>

          {/* Modal for Delete */}
          <ModalPopover
            modalId="modalForDelete" dismiss="false" isModal="true"
            ref={modalForDelete => this.modalForDelete = modalForDelete}
          >
            <div className="wrap modalWrapper">
              <div className="row headOptionModal">
                <div className="col-xs-8 pl-0"> <span className="titleOptionModal">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.delete.elimination.article.buttton.label')}</span></div>              </div>
              <div className="row">
                <div className='col-xs-12'>
                  {/* <div className="label">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.qty.label')}</div> */}
                  <div className="deleteGiftConfirmationMsg">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.delete.elimination.confirmation.modal')}</div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-6">
                  <InputButton buttonAttr={DeleteButtonforGift} />
                </div>
                <div className="col-xs-6">
                  <InputButton buttonAttr={CancelDeleteButtonforGift} />
                </div>
              </div>
            </div>
          </ModalPopover>

          
          {/* Modal for Gift Certificates */}

          <ModalPopover
            modalId="modalOptionCertificate" dismiss="false" isModal="true"
            ref={modalForSetFavourite => this.modalForSetFavourite = modalForSetFavourite}
          >

            <div className="wrap modalWrapper">
              <div className="row headOptionModal">
                <div className="col-xs-8 title-padd"> <span className="titleOptionModal">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.gift.settings')}</span></div>
                {headerData}
              </div>
              <div className="row">
                <div className="col-xs-12 contentfavGift-wrapper">
                  <div className='row'>
                    <div className='col-xs-12 qty-section'>
                      <div className="formBlock">
                        <div className="contentQuantity">
                          <div className="label">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.qty.label')} :</div>
                          <div className="spiner bootstrap-touchspin">
                            <span className="btn btn-default bootstrap-touchspin-down" onClick={this.state.count <= 1 ? this.showModalForDeleteModalFromGiftCertificate : this.decrement}>
                              {this.state.count <= 1 ? ( <img src={commonUtil.getAssetURL() + "/images/delete.svg"} alt="" className='modalIcons' />) : (<span className='glyphicon glyphicon-minus'/>)}
                            </span>
                            {/* <input id="touchspin_3" type="number" onChange={this.quantityUpdate} value={this.state.count} name="demo_vertical" /> */}
                            <input id="touchspin_3" type="number" value={this.state.count} name="demo_vertical" readOnly/>
                            <span className="btn btn-default bootstrap-touchspin-up" disabled>
                              <img src={commonUtil.getAssetURL() + "/images/add.svg"} alt="" className='modalIcons' />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='mode_address_change'>
                      <div class="panel-group">
                        <div class="panel panel-default">
                          <div class="panel-heading">
                            <h4 class="panel-title">
                              <span><strong>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.gift.mode')}</strong><span className='electronics-text-wap'>:{' '}{defaultConst.constGiftDeliveryMode.Electrónicos == 'electronic' && 'Electrónico'}</span></span>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="contentFavGift regaloFavElectro">
                      <div className="label">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.item.mark.as.favorite.gift')}
                        <MobileTooltip
                          lables={this.props.lables}
                        />
                      </div>
                      <div className="select">
                        <Favourite
                          ref={favourite => this.favouriteGC = favourite}
                          id={this.state.selectedGiftItem.skuId}
                          onchange={e => this.setFavouriteGiftValue(e, this.state.selectedGiftItem)}
                          item={this.state.selectedGiftItem}
                          checked={this.state.isFavourite}
                          channel="WAP"
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <InputButton buttonAttr={SaveButtonforGiftCertificate} />
                </div>
              </div>
            </div>
          </ModalPopover>

          <ModalPopover
            modalId="filterModal" dismiss="false" isModal="true" isWapFull="true"
            ref={filterModal => this.filterModal = filterModal}
          >
            <div className="wrap wrapWap">
              <div className="row headOptionModal">
                <div className="col-xs-8"> <span className="titleOptionModal"> Filtrar </span></div>
                <div className="col-xs-4 text-right closeOptionModal" onClick={this.handleCloseFilterModal}>
                  <img
                  src={commonUtil.getAssetURL() + "/images/close.svg"}
                  alt=""
                  className="icon_vozcliente"
                /></div>
              </div>
              {this.state.activeCategory && (
              <div className="filter-container">
                {this.state.selectedFilters.map((filter, idx) => (
                  <FilterTag
                    key={idx}
                    label={filter}
                    onRemove={() => this.removeFilter(filter)}
                  />
                ))}
              </div>
              )}
              <div className="row">
                <div className="col-xs-12">
                  <div className='row'>
                    <div className='mode_filter_change' style={{ padding: '0px 24px'}}>
                      <Accordion items={accordianFilterData} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 registeredButtonsSection">
                <div className="filter-button-group">
                  {this.state.activeCategory && (
                    <InputButton 
                      buttonAttr={ClearButtonforFilter}
                    />
                  )}
                  <InputButton 
                    buttonAttr={SaveButtonforFilter}
                  />
                </div>
              </div>
            </div>
          </ModalPopover>
          {/* {registeredItemsFound && this.props.compareEventStatus(this.props.eventStatus, predefinedStatus) &&
            <Fragment>
              <div className="row">
                <div className="col-xs-12">
                  <div className="selectAllRG">
                    <CheckBox
                      displayName={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label')}
                      id="selectRegisteredGiftAll"
                      name="check"
                      checkStatus="false"
                      getSelectedValue={this.showHidden}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
              </div>
              <hr />
            </Fragment>
          } */}
          {!registeredItemsFound ? (
            <>
            <EmptyGiftListIndicator giftList={`${this.initialGiftListItems.totalRecords == 0 ? 'registered': 'registered_noSearchResults'}`} style={{ marginBottom: '2rem', marginTop: '4rem' }} />
              {/* <div className="row text-center" style={{ paddingBottom: '5rem' }}>
                <div className="col-xs-12">
                  <a
                    style={{ color: currentBrandColors.primary, textDecoration: 'underline', cursor: 'pointer' }}
                    href={`${serverClientUtil.getLPFullURL()}/home`}
                  >
                    {commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.homepage.link.label')}
                  </a>
                </div>
              </div> */}
            </>
          ) : (
            <Fragment>
              <div className="row text-right" style={{ marginBottom: '1rem' }}>
                <div className="col-xs-12" style={{background:'#FFFFFF'}}>
                  <b>{allRegisteredItems.length} de {totalRegisteredGifts}</b> productos
                </div>
              </div>
              <div className="row">
                {registeredGifts.map((giftItem, key) => (
                  <div className="col-xs-12 giftItemSection">
                    <table className="tableRegisteredGifts tableregister-gift-td">
                      <tbody>
                        <Template1
                          key={key}
                          showUpdateGiftDetailsModalWithProductData={
                            giftItem.categoryName === 'Gift Certificate' ||
                            giftItem.categoryName === 'Certificado Electrónico'
                              ? this.showCertificateDetailsModalWithProductData
                              : this.showUpdateGiftDetailsModalWithProductData
                          }
                          selectedItem={this.selectedItem}
                          selectedThisItem={
                            this.state.selecetdGiftItem.filter(item => item === giftItem.giftItemId).length
                          }
                          eventId={this.props.eventId}
                          giftDetail={giftItem}
                          categoryName={giftItem.categoryName}
                          eventStatus={this.props.eventStatus}
                          compareEventStatus={this.props.compareEventStatus}
                          registeredGiftList={this.props.registeredGiftList}
                          lables={this.props.lables}
                          handleBulkAction={this.props.handleBulkAction}
                          getRegisteredGiftList={this.props.getRegisteredGiftList}
                          deliveryAddressInfo={this.deliveryAddressInfo}
                          activeCategory={this.state.activeCategory}
                          handleSortAndFilter = {this.props.handleSortAndFilter}
                          categoryDepartmentId = {this.state.categoryDepartmentId}
                        />
                      </tbody>
                    </table>
                  </div>
                ))}
                {registeredGiftCertificates.length > 0 && (
                 <div className="col-xs-12">
                <div className='certi-regalo'>
                  <div className='certi-regalo-title'>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.certi.regalo.title.label')}</div>
                  <div className='certi-regalo-subtitle'>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.certi.regalo.subtitle.label')}</div>
                </div>
              </div>
                )}
                {registeredGiftCertificates.map((giftItem, key) => (
                  <div className="col-xs-12">
                    <table className="tableRegisteredGifts tableregister-gift-td">
                      <tbody>
                        <Template1
                          key={key}
                          showUpdateGiftDetailsModalWithProductData={
                            giftItem.categoryName === 'Gift Certificate' ||
                            giftItem.categoryName === 'Certificado Electrónico'
                              ? this.showCertificateDetailsModalWithProductData
                              : this.showUpdateGiftDetailsModalWithProductData
                          }
                          selectedItem={this.selectedItem}
                          selectedThisItem={
                            this.state.selecetdGiftItem.filter(item => item === giftItem.giftItemId).length
                          }
                          eventId={this.props.eventId}
                          giftDetail={giftItem}
                          categoryName={giftItem.categoryName}
                          eventStatus={this.props.eventStatus}
                          compareEventStatus={this.props.compareEventStatus}
                          registeredGiftList={this.props.registeredGiftList}
                          lables={this.props.lables}
                          handleBulkAction={this.props.handleBulkAction}
                          getRegisteredGiftList={this.props.getRegisteredGiftList}
                          categoryDepartmentId ={this.state.categoryDepartmentId}
                          deliveryAddressInfo={this.deliveryAddressInfo}
                          handleSortAndFilter = {this.props.handleSortAndFilter}
                        />
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
              <div className="row text-center" style={{backgroundColor: '#fff'}}>
                <div style={{ marginTop: '3rem' }}>
                  {allRegisteredItems.length < totalRegisteredGifts && (
                    <div className="col-xs-12" style={{ marginBottom: '1rem' }}>
                      <InputButton buttonAttr={loadMoreButton} />
                    </div>
                  )}
                  {/* <div className="col-xs-12" style={{ marginBottom: showBackToTopButton ? undefined : '1rem' }}>
                    {allRegisteredItems.length} de {totalRegisteredGifts} resultados
                  </div> */}
                  {showBackToTopButton && this.state.showButton && (
                    <div className="col-xs-12">
                      <InputButton buttonAttr={goToTopButton} />
                    </div>
                  )}
                </div>
              </div>
            </Fragment>
          )}
          {/* <div className="row text-center">
            <div className="col-xs-12">
              <a
                style={{ color: currentBrandColors.primary, textDecoration: 'underline' }}
                onClick={this.props.onAddGiftsLinkClick}
              >
                Agregar regalos a mi lista
              </a>
            </div>
          </div> */}

          <AddGiftsButton
            selectedTheme ={this.props.selectedTheme}
            lables = {this.props.lables}
            isDisable = {isDisabled}
          />

          {/* Modal for Gift Detials  */}
          <ModalPopover
            modalId="modalOptions"
            dismiss="false" isModal="true"
            ref={updateGiftDetails => this.updateGiftDetails = updateGiftDetails}
          >
            <div className="">
              <div className="row headOptionModal">
                <div className="col-xs-8 pl-0"> <span className="titleOptionModal">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.gift.settings')}</span></div>
                {headerData}
              </div>
              <div className="row">
                <div className="col-xs-12">

                  <div className='row'>
                    <div className='col-xs-12 qty-section'>
                      <div className="formBlock">
                        <div className="contentQuantity">
                          <div className="label">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.qty.label')} :</div>
                          <div className="spiner bootstrap-touchspin">
                            <span className="btn btn-default bootstrap-touchspin-down" onClick={this.state.count <= 1 ? this.showModalForDeleteModal : this.decrement}>
                              {this.state.count <= 1 ? ( <img src={commonUtil.getAssetURL() + "/images/delete.svg"} alt="" className='modalIcons' />) : (<span className='glyphicon glyphicon-minus'/>)}
                            </span>
                            <input id="touchspin_3" type="number" onChange={this.quantityUpdate} value={this.state.count} name="demo_vertical" onKeyDown={this.handleAllowOnlyDigit} onPaste={this.onPasteFunc} />
                            <button className="btn btn-default bootstrap-touchspin-up" onClick={this.increment} disabled={this.state.count >= 999} style={{opacity: this.state.count >= 999 ? '0.5' : 'unset'}}>
                              <img src={commonUtil.getAssetURL() + "/images/add.svg"} alt="" className='modalIcons' />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='mode_address_change'>
                      <Accordion items={accordionData} />
                    </div>
                  </div>
                  
                  {/* <div className="formBlock">
                    <label htmlFor="giftMode"></label>

                    <SelectionTab
                      id={CambiarModoDeRegalos.id}
                      classname="cSelect"
                      dropDownClass={'customFormControl'}
                      options={CambiarModoDeRegalos.options}
                      optionText={'labelResourceId'}
                      optionValue={'value'}
                      value={CambiarModoDeRegalos.defaultValue}
                      ref={ref => this.modeOfDeliveryId = ref}
                      handleSelectedOption={this.deliveryModeIndividualGiftUpdate}

                    />
                  </div> */}
                  {/* {this.state.selectedGiftItem.deliveryMode === 'physical' ?
                    <div className="formBlock">
                      <label htmlFor="giftAddress">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.item.address.label')}</label>

                      <React.Fragment>
                        {!(this.props.compareEventStatus(this.props.eventType, eventTypes)) ?
                          <SelectionTab
                            options={this.deliveryAddressDetails}
                            classname="cSelect"
                            dropDownClass={'customFormControl'}
                            optionText={'value'}
                            optionValue={'id'}
                            // optionCaption={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.category.dropdown.label1')}
                            // isCaptionDisabled={false}
                            value={this.state.selectedGiftItem.addressId}
                            ref={ref => this.deliveryAddressID = ref}
                          />
                   : <span> {this.deliveryAddressDetails && this.deliveryAddressDetails[0] ? this.deliveryAddressDetails[0].value : null} </span>}</React.Fragment>
                    </div> : ''} */}


                </div>
                <div className="col-xs-12 selectFavGift">
                  <div className="favGift" />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 contentfavGift-wrapper pl-0 pr-0">
                  <div className="form-group">
                    <div className="contentFavGift">
                      <div className="label">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.item.mark.as.favorite.gift')}
                        <MobileTooltip
                          lables={this.props.lables}
                        />
                      </div>
                      <div className="select">
                        <Favourite
                          ref={favourite => this.favourite = favourite}
                          id={this.state.selectedGiftItem.skuId}
                          onchange={e => this.setFavouriteGiftValue(e, this.state.selectedGiftItem)}
                          item={this.state.selectedGiftItem}
                          checked={this.state.isFavourite}
                          channel="WAP"
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <InputButton buttonAttr={SaveButton} />
                </div>
              </div>
            </div>

          </ModalPopover>
        </div>
        <div className="footerBarOptions" id="footerBarOptionsRegisteredGifts" style={{ display: 'none' }}>
          <div className="row customRow">
            <div className="col-xs-2 qb br deletebarItem text-center">
              <a href="javascript:void(0)">
                <span className="iclass icon-basura" onClick={this.removeItemsFromGiftlist} /></a>
            </div>
            <div className="col-xs-6 qb br">
              <SelectOption
                id={CambiarModoDeRegalosOptionsForBulkAction.id}
                className={'specialSelect'}
                captionClass={'btns-footer'}
                selectCaption={CambiarModoDeRegalosOptionsForBulkAction.selectCaption}
                list={CambiarModoDeRegalosOptionsForBulkAction.options}
                optionText={'labelResourceId'}
                optionValue={'value'}
                onOptionClickHandler={this.changeDeliveryModeOption}
              />

            </div>
            <div className="col-xs-4 qb br">
              <SelectOption
                id={DireccionOptionsForBulkAction.id}
                className={'specialSelect'}
                captionClass={'btns-footer'}
                selectCaption={DireccionOptionsForBulkAction.selectCaption}
                list={DireccionOptionsForBulkAction.options}
                optionText={'labelResourceId'}
                optionValue={'value'}
                onOptionClickHandler={this.changeDeliveryAddressOption}
              />
            </div>
            <div className="col-xs-2 qb closebar">
              <a href="javascript:void(0)" id="closeFooterRegisteredGifts">
                <span onClick={this.hideAndReset} className="iClass icon-tache2" /></a>
            </div>
          </div>
        </div>
      </React.Fragment >
    );
  }
}
const mapStateToProps = state => ({
  location: state.routing.locationBeforeTransitions.pathname,
  eventStatus: state.giftList && state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventStatus,
  eventDate: state.giftList && state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventDate,
  eventId: state.giftList && state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventId,
  eventType: state.giftList && state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventType,
  printingDate: state.info && state.info.data && state.info.data.time,
});
const matchDispatchToProps = dispatch => bindActionCreators(
  {
    removeItemsFromGiftlist,
    changeDeliveryAddress,
    changeDeliveryMode,
    setFavouriteGift,
    getRegisteredGiftList,
    updateFavouriteToRegisteredGiftList,
  }, dispatch);


export default connect(mapStateToProps, matchDispatchToProps)(RegistradosContent);